<div class="edit-bar" [class.is-editing]="state === 'editing'" [class.is-locked]="state === 'locked'" role="status">
  @switch (state) {
    @case ('loading') {
      <span class="muted">Checking who is editing…</span>
    }
    @case ('view') {
      <span class="mode">View only</span>
      <button type="button" class="act act-sm" (click)="startEdit()" [disabled]="busy || !entityId">
        {{ busy ? 'Opening…' : 'Edit' }}
      </button>
    }
    @case ('editing') {
      <span class="mode mode-editing">Editing</span>
      <span class="hint-text">Other admins see this {{ noun }} as view-only until you finish.</span>
      <button type="button" class="act-ghost act-sm" (click)="done()">Done</button>
    }
    @case ('locked') {
      <span class="mode mode-locked">View only</span>
      <span class="hint-text">
        {{ holderName || 'Another admin' }} is editing this {{ noun }}@if (since) { since {{ since | date: 'shortTime' }}}.
        You can edit once they finish.
      </span>
      <button type="button" class="act act-sm" disabled>Edit</button>
    }
  }
</div>
@if (notice) {
  <div class="note note-warn edit-notice">{{ notice }}</div>
}
